import * as React from 'react';

const Loader: React.SFC = () => (
  <div className="async-loader">
    <div className="background">
      <div className="animation">
        <div className="loader" />
      </div>
    </div>
  </div>
);

export default Loader;



// WEBPACK FOOTER //
// ./src/components/loader/Loader.tsx